import React from "react";
import "../css/property-intro.css";

const features = [
  {
    title: "Casas",
    description:
      "Encontre a casa dos seus sonhos com amplos espaços, jardim e privacidade para toda sua família.",
    icon: "home",
  },
  {
    title: "Apartamentos",
    description:
      "Apartamentos modernos com estrutura completa, segurança e localização privilegiada na cidade.",
    icon: "building",
  },
  {
    title: "Terrenos",
    description:
      "Terrenos prontos para construir seu projeto ideal. Áreas residenciais e comerciais disponíveis.",
    icon: "land",
  },
];

const FeatureIcon = ({ name }) => (
  <svg
    className="property-feature-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {name === "home" && (
      <>
        <path d="m3 10 9-7 9 7" />
        <path d="M5 9v11h14V9M9 20v-7h6v7" />
      </>
    )}
    {name === "building" && (
      <>
        <path d="M5 21V4l9-2v19M5 7h9M8 10h2m2 0h1m-5 4h2m2 0h1m-5 4h2m2 0h1m4-6h2v9h-6" />
      </>
    )}
    {name === "land" && (
      <>
        <path d="m12 3 8 3v5c0 5-3.4 8.2-8 10-4.6-1.8-8-5-8-10V6l8-3Z" />
        <path d="m8 13 2.5 2.5L16 10" />
      </>
    )}
  </svg>
);

const PropertyIntro = () => (
  <section className="property-intro" aria-labelledby="property-intro-title">
    <div className="property-intro-container">
      <header className="property-intro-heading">
        <h2 id="property-intro-title">
          Vamos encontrar o imóvel perfeito para você!
        </h2>
        <p>
          Oferecemos uma ampla variedade de imóveis para atender suas
          necessidades. Seja casa, apartamento ou terreno, temos a opção ideal
          para você e sua família.
        </p>
      </header>

      <div className="property-intro-content">
        <div className="property-feature-list">
          {features.map((feature) => (
            <article className="property-feature" key={feature.title}>
              <div className="property-feature-badge">
                <FeatureIcon name={feature.icon} />
              </div>
              <div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="property-intro-image-wrap img-about dots">
          <img
            className="property-intro-image"
            src="https://api.gestorimobiliario360.com.br/api/media/ae65a36a644dedf0b189c6669669f5e3d3496c9893d9e1022e9e5794d5bc3555"
            alt="Edifício residencial em uma rua arborizada"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </section>
);

export default PropertyIntro;
